class Attribute {
    constructor(name, def) {
        this.name = name;
        this.label = def.label;
        this.type = def.type;
        this.input = def.input;
        this.valueSet = def.valueSet;
        this.prefillExpression = def.jsPrefill;
    }

    fromJson(data) {
        if (data && (this.type === 'date' || this.type === 'datetime')) {
            return new Date(data*1000);
        }
        return data;
    }

    toJson(value) {
        if (value && (this.type === 'date' || this.type === 'datetime')) {
            return Math.round(value.getTime() / 1000);
        }
        return value;
    }

    getValues(){
        if (this.valueSet) {
            return this.valueSet;
        }
        return {};
    }
}

export default Attribute;